<template>
  <div style="margin-top: 100px;">
   <loading v-if="loading"/>

    <v-row v-else  justify="center"  class="mt-16 mx-16">
      <v-col  cols="4">
        <v-img :src="productDetail.photo_file"></v-img>
      </v-col>
      <v-col dir="auto" class="pr-6">
        <h1 class="font-weight-bold">{{productDetail.title}}</h1>
        <div class="label">{{productDetail.title}}</div>
       <div v-html="productDetail.details"></div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "single",
  created() {
    if (this.$route.params.name==='ajor'||this.$route.params.name==='block'){
      this.$store.dispatch('lightBlocksManagement/getProductDetails',{
        url:this.blockProducts.find(item=>item.en===this.$route.params.name)
      });
    }
    else{
      this.$store.dispatch('lightBlocksManagement/getProductDetails',{
        url:this.products.find(item=>item.en===this.$route.params.name)
      });
    }
  },
  computed:{
    ...mapState({
      blockProducts:state => state.lightBlocksManagement.blockProducts,
      products:state => state.lightBlocksManagement.products,
      productDetail:state => state.lightBlocksManagement.productDetails,
      loading:state => state.lightBlocksManagement.loading,
    })
  },
}
</script>

<style scoped>
.label{
  background: #7BAD32;
  color: #FFFFFF;
  max-width: max-content;
  padding: 4px;
  margin: 16px 0;
  font-size: 24px;
}
</style>